import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, Mousewheel } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-cards';

import '../allcss/imageeffect.css';

// Import local images from Slider_Gallery
import image1 from '../Slider_Gallery/gallery5.jpeg';
import image2 from '../Slider_Gallery/2.jpeg';
import image3 from '../Slider_Gallery/3.jpeg';
import image4 from '../Slider_Gallery/4.jpeg';
import image5 from '../Slider_Gallery/gallery4.jpeg';
import image6 from '../Slider_Gallery/gallery3.jpeg';
import image7 from '../Slider_Gallery/gallery2.jpeg';
import image8 from '../Slider_Gallery/8.jpeg';
import image9 from '../Slider_Gallery/9.jpeg';
import image10 from '../Slider_Gallery/10.jpeg';

const MovieNight = () => {
  const providedImageLinks = [
    image8, image1, image2, image3, image4, image5,
    image6, image7, image9, image10
  ];

  const movies = [
    { rating: '8.5', title: "The Queen's Gambit" },
    { rating: '9.5', title: 'Breaking Bad', imgClass: 'custom-img-position' },
    { rating: '8.1', title: 'Wednesday' },
    { rating: '8.7', title: 'Stranger Things' },
    { rating: '8.6', title: 'Anne with an E' },
    { rating: '8.9', title: 'Friends' },
    { rating: '8.6', title: 'The Crown', imgClass: 'custom-img-position' },
    { rating: '8.7', title: 'House M.D.' },
    { rating: '9.2', title: 'Game of Thrones' },
  ].map((movie, index) => ({
    ...movie,
    imgSrc: providedImageLinks[index % providedImageLinks.length],
  }));

  return (
    <section id="get-started" className="custom-section">
      <div className="custom-content">
        <div className="custom-info">
          <h2 className="custom-highlight">
            Admissions Open for the <br /> New Academic Session
          </h2>

          <p>
          Give your child a joyful start to learning at RED School House. Our Playgroup, Nursery, Junior KG, Senior KG, and Day Care programs provide a safe, nurturing, and engaging environment where children learn, grow, and thrive every day.
          </p>
          <a href="#contact" className="custom-btn">Book a School Tour</a>
        </div>

        <Swiper
          effect={'cards'}
          grabCursor={true}
          initialSlide={0}
          speed={500}
          loop={true}
          mousewheel={{ invert: false }}
          modules={[EffectCards, Mousewheel]}
          className="custom-swiper"
        >
          {movies.map((movie, index) => (
            <SwiperSlide key={index}>
              <img
                src={movie.imgSrc}
                alt={movie.title}
                className={movie.imgClass || ''}
              />
              <div className="custom-overlay" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <ul className="custom-circles">
        {Array.from({ length: 10 }).map((_, index) => (
          <li key={index}></li>
        ))}
      </ul>
    </section>
  );
};

export default MovieNight;
